import { Box, Typography } from '@mui/material';
import { InfoTooltip } from '~/components/Tooltip/InfoTooltip';

interface CardHeaderProps {
  title: string;
  tooltip?: string;
}

export const CardHeader = ({ title, tooltip }: CardHeaderProps) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
    <Typography component="h2" variant="subtitle1" fontWeight={600}>
      {title}
    </Typography>
    {tooltip && <InfoTooltip title={tooltip} placement="top" />}
  </Box>
);
